var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-internet"},[_c('div',{staticClass:"img"},[_c('NoInternetIcon')],1),_vm._v(" "),_c('div',{staticClass:"error-text"},[_c('h2',[_vm._v(_vm._s(_vm.$t('something_went_wrong'))+"!")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('disconnect_and_retry')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }